import React from "react";
import images from "ressources/images";

const CategoryListItem = ({ logo, title }) => {
  const backgroundImage = logo || images.default_category_bg;
  return (
    <div
      className="brands-list-item"
      style={{
        // height: "calc(14rem + (" + size + " * 16rem))",
        backgroundImage: "url(" + backgroundImage + ")",
      }}
    >
      <span className="title">{title}</span>
    </div>
  );
};

export default CategoryListItem;
